// sensei-app/client/mainLayout.js

export default {
    defaultRoute: '/entry/login',
    defaultRoutes: {
        public: '/entry/login',
        student: '/student/dashboard',
        parent: '/parent/dashboard',
        courseAdmin: '/course-admin/dashboard',
        admin: '/admin/dashboard',
        login: '/entry/login',
        entry: '/entry',
    },

    layers: {
        base: {
            template: `
                <div id="root-container-wrapper" class="vh-100 overflow-hidden">
                    <div id="dev-tools-container"></div>
                </div>
            `,
            container: 'app-container',
            components: [
                { name: 'entry-layer', type: 'layer', layer: 'entry', container: 'root-container-wrapper' },
                { name: 'onboarding-layer', type: 'layer', layer: 'onboarding', container: 'root-container-wrapper' },
                { name: 'app-layer', type: 'layer', layer: 'app', container: 'root-container-wrapper' },
                { name: 'classroom-layer', type: 'layer', layer: 'classroom', container: 'root-container-wrapper' },
                { name: 'assessment-layer', type: 'layer', layer: 'assessment', container: 'root-container-wrapper' },
                { name: 'assignment-layer', type: 'layer', layer: 'assignment', container: 'root-container-wrapper' },
                { name: 'error-layer', type: 'layer', layer: 'error', container: 'root-container-wrapper' },
                { name: 'devtools', type: 'DevTools', container: 'dev-tools-container', instanceId: 'senseiDevTools' },
                { name: 'payment-gateway', type: 'PaymentGatewayComponent', container: 'root-container-wrapper' },

            ]
        },


        onboarding: {
            route: '/onboarding',
            hideInMenu: true,
            template: `
                <div class="d-flex justify-content-center align-items-center vh-100" style="background-color: var(--bs-tertiary-bg);">
                    <div id="onboarding-wizard-container" class="card shadow-sm" style="width: 100%; max-width: 600px; min-height: 500px;">
                        <!-- The SenseiOnboardingWizard component will render here -->
                    </div>
                </div>
            `,

            components: [
                {
                    name: 'sensei-onboarding-wizard',
                    type: 'SenseiOnboardingWizard',
                    container: 'onboarding-wizard-container'
                }
            ]
        },


        classroom: {
            route: '/student/classroom', hideInMenu: true,
            template: `<div id="fullscreen-classroom-container" class="w-100 vh-100"></div>`,
            components: [
                { name: 'student-classroom-view', type: 'StudentClassroomView', container: 'fullscreen-classroom-container' }
            ]
        },

        assessment: {
            route: '/student/assessment', hideInMenu: true,
            template: `<div id="fullscreen-assessment-container" class="w-100 vh-100"></div>`,
            components: [
                { name: 'student-assessment-view', type: 'StudentAssessmentView', container: 'fullscreen-assessment-container' }
            ]
        },


        assignment: {
            route: '/student/assignment', hideInMenu: true,
            template: `<div id="fullscreen-assignment-container" class="w-100 vh-100"></div>`,
            components: [
                { name: 'student-assignment-view', type: 'StudentAssignmentView', container: 'fullscreen-assignment-container' }
            ]
        },

        app: {
            route: '/(student|parent|course-admin|admin)', // Regex route to match all app sections
            template: `
                <div id="sensei-app-wrapper" class="d-flex flex-column h-100">
                    <header id="main-header-area" class="app-header"></header>
                    <main id="main-content-area" class="flex-grow-1 overflow-hidden"></main>
                </div>
            `,
            components: [
                // These components are part of the app shell and are always visible
                { name: 'sensei-header', type: 'layer', layer: 'shared-header', container: 'main-header-area' },

                // These layers are the main content and are switched based on the route
                { name: 'student-app-layer', type: 'layer', layer: 'student', container: 'main-content-area' },
                { name: 'parent-app-layer', type: 'layer', layer: 'parent', container: 'main-content-area' },
                { name: 'courseAdmin-app-layer', type: 'layer', layer: 'courseAdmin', container: 'main-content-area' },
                { name: 'admin-app-layer', type: 'layer', layer: 'admin', container: 'main-content-area' },
            ]
        },
        // --- END: NEW APP LAYER ---

        "shared-header": {
            template: `
                <nav class="navbar navbar-expand shadow-sm h-100" style="-webkit-app-region: drag;">
                    <div class="container-fluid">
                        <div id="sensei-logo-container" style="-webkit-app-region: no-drag;"></div>
                        <div id="shared-header-actions" class="d-flex align-items-center ms-auto h-100" style="-webkit-app-region: no-drag;">
                         <div id="role-switcher-container" class="ms-2"></div>
                        <div id="notifications-container" class="ms-2"></div>
                        <div id="documentation-link-container" class="ms-2"></div>
                        <div id="user-profile-menu-container" class="ms-2"></div>
                        <div id="common-titlebar-controls" class="electron-only-titlebar-host h-100 ms-2"></div>
                        </div>
                    </div>
                </nav>
            `,
            components: [
                {
                    name: 'sensei-logo',
                    type: 'LogoComponent',
                    container: 'sensei-logo-container',
                    props: {
                        desktopLogoUrl: '/public/logo.png',
                        mobileLogoUrl: '/public/android-chrome-192x192.png',
                        desktopImageHeight: '35px'
                    }
                },
                {
                    name: 'sensei-role-switcher',
                    type: 'RoleSwitcher',
                    container: 'role-switcher-container',
                    props: {
                        // Hide the switcher for these primary roles, even if they have
                        // access to other sections (which they don't in Sensei's case).
                        hideFor: ['student', 'parent'],
                        roleIcons: {
                            admin: 'bi-shield-lock-fill',
                            courseAdmin: 'bi-person-video3',
                            parent: 'bi-people-fill',
                            student: 'bi-mortarboard-fill'
                        },
                        switchableRoles: ['student', 'courseAdmin', 'admin']


                    }
                },
                { name: 'notifications-menu', type: 'Notifications', container: 'notifications-container' },
                { name: 'documentation-link', type: 'DocumentationLink', container: 'documentation-link-container' },

                {
                    name: 'user-profile-menu',
                    type: 'UserProfileMenu',
                    container: 'user-profile-menu-container',
                    props: {
                        showThemeSelector: true,
                        menuItems: [{ title: "My Profile", route: "/student/profile" }]
                    }
                },
                { name: 'titlebar-controls', type: 'TitleBarControls', container: 'common-titlebar-controls' },
            ]
        },
        entry: {
            route: '/entry',
            template: `
                <div class="ab-entry-page">
                    <div id="entry-titlebar-controls" class="electron-only-titlebar-host w-100 d-flex justify-content-end pe-2" style="position: absolute; top: 0; left: 0; height: 48px; -webkit-app-region: drag; z-index: 9999;">
                        <div id="entry-titlebar-controls-target" class="h-100" style="-webkit-app-region: no-drag;"></div>
                    </div>
                    <div class="ab-entry-branding">
                        <div id="entry-branding-logo" class="mb-4"></div>
                        <h1 class="ab-entry-headline" data-i18n="A Creative Path to Academic Mastery">A Creative Path to Academic Mastery</h1>
                        <p class="ab-entry-subline" data-i18n="Whether you're preparing for exams or exploring a new passion, Sensei provides the personalized tools you need to learn and build for the modern world.">Whether you're preparing for exams or exploring a new passion, Sensei provides the personalized tools you need to learn and build for the modern world.</p>
                        <ul class="ab-entry-features">
                            <li>
                                <i class="bi bi-bullseye"></i>
                                <div><strong data-i18n="Define Your Goal">Define Your Goal</strong><br><span data-i18n="Tell your AI Coordinator your learning objectives, and it will build a personalized curriculum just for you.">Tell your AI Coordinator your learning objectives, and it will build a personalized curriculum just for you.</span></div>
                            </li>
                            <li>
                                <i class="bi bi-easel2-fill"></i>
                                <div><strong data-i18n="Learn Interactively">Learn Interactively</strong><br><span data-i18n="Engage in one-on-one lessons with your AI Tutor, using an interactive whiteboard and multimodal inputs.">Engage in one-on-one lessons with your AI Tutor, using an interactive whiteboard and multimodal inputs.</span></div>
                            </li>
                            <li>
                                <i class="bi bi-patch-check-fill"></i>
                                <div><strong data-i18n="Achieve Mastery">Achieve Mastery</strong><br><span data-i18n="Solidify your knowledge with adaptive assessments that provide instant, detailed feedback.">Solidify your knowledge with adaptive assessments that provide instant, detailed feedback.</span></div>
                            </li>
                        </ul>
                    </div>
                    <div class="ab-entry-card-container">
                        <div class="ab-entry-card">
                            <div id="entry-mobile-logo" class="ab-entry-mobile-logo"></div>
                            <div id="entry-component-target"></div>
                            <div class="ab-entry-card-footer">
                                <a href="/entry/login" data-i18n="Login">Login</a>
                                <span>·</span>
                                <a href="/entry/signup" data-i18n="Sign Up">Sign Up</a>
                                <span>·</span>
                                <a href="/entry/forgot-password" data-i18n="Forgot Password">Forgot Password</a>
                            </div>
                        </div>
                    </div>
                    <div class="ab-entry-terms">
                        <span>By continuing, you agree to our <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy Policy</a>.</span>
                    </div>
                </div>
            `,
            components: [
                { name: 'branding-logo', type: 'LogoComponent', container: 'entry-branding-logo', props: { desktopLogoUrl: '/public/logo.png', desktopImageHeight: '40px', logoText: 'Sensei' } },
                { name: 'mobile-logo', type: 'LogoComponent', container: 'entry-mobile-logo', props: { desktopLogoUrl: '/public/logo.png', desktopImageHeight: '40px', logoText: 'Sensei' } },
                { name: 'titlebar-controls-entry', type: 'TitleBarControls', container: 'entry-titlebar-controls-target' },
                { name: 'login-form-layer', type: 'layer', layer: 'login', container: 'entry-component-target', default: true },
                { name: 'signup-form-layer', type: 'layer', layer: 'signup', container: 'entry-component-target' },
                { name: 'forgotpassword-form-layer', type: 'layer', layer: 'forgotpassword', container: 'entry-component-target' }
            ]
        },

        "login": {
            route: '/entry/login',
            template: `<div id="login-component-target"></div>`,
            components: [
                { name: 'login-component', type: 'Login', container: 'login-component-target', instanceId: 'senseiLogin' }
            ]
        },
        "signup": {
            route: '/entry/signup',
            template: `<div id="signup-component-target"></div>`,
            components: [
                { name: 'signup-component', type: 'Signup', container: 'signup-component-target', instanceId: 'senseiSignup' }
            ]
        },
        "forgotpassword": {
            route: '/entry/forgot-password',
            template: `<div id="forgotpassword-component-target"></div>`,
            components: [
                { name: 'forgotpassword-component', type: 'ForgotPassword', container: 'forgotpassword-component-target', instanceId: 'senseiForgotPwd' }
            ]
        },

        "student": {
            route: '/student',
            template: `
                <div class="d-flex h-100">
                    <nav id="student-sidebar-menu" class="app-sidebar"></nav>
                    <div id="student-content-area" class="flex-grow-1 overflow-auto"></div>
                </div>
            `,
            components: [
                {
                    name: 'student-menu',
                    type: 'AppMenu',
                    container: 'student-sidebar-menu',
                    props: {
                        startingRoute: '/student/',
                        fullHeight: true,
                        collapsible: true,
                        defaultCollapsed: true,
                        saveState: true
                    }
                },
                { name: 'student-content-layer', type: 'layer', layer: 'student-content', container: 'student-content-area', default: true },
            ]
        },
        "student-content": {
            template: `<div id="student-feature-area" class="h-100"></div>`,
            components: [
                { name: 'student-dashboard-layer', type: 'layer', layer: 'student-dashboard', container: 'student-feature-area', default: true },
                { name: 'student-calendar-layer', type: 'layer', layer: 'student-calendar', container: 'student-feature-area' },
                { name: 'student-coordinator-layer', type: 'layer', layer: 'student-coordinator', container: 'student-feature-area' },
                { name: 'student-documentation-layer', type: 'layer', layer: 'student-documentation', container: 'student-feature-area' },
                { name: 'student-schedule-list-layer', type: 'layer', layer: 'student-schedule-list', container: 'student-feature-area' },
                { name: 'student-courses-layer', type: 'layer', layer: 'student-courses', container: 'student-feature-area' },
                { name: 'student-profile-layer', type: 'layer', layer: 'student-profile', container: 'student-feature-area' },
                { name: 'student-certificates-layer', type: 'layer', layer: 'student-certificates', container: 'student-feature-area' },
                { name: 'student-billing-layer', type: 'layer', layer: 'student-billing', container: 'student-feature-area' },

            ]
        },
        "student-dashboard": {
            route: '/student/dashboard',
            menuItem: true, menuTitle: 'Dashboard', menuIcon: 'bi-house-door', menuOrder: 1,
            template: `<div id="student-dashboard-component" class="h-100"></div>`,
            components: [
                { name: 'student-dashboard-main', type: 'StudentDashboard', container: 'student-dashboard-component', instanceId: 'studentDashboard' }
            ]
        },

        "student-calendar": {
            route: '/student/calendar',
            menuItem: true, menuTitle: 'My Calendar', menuIcon: 'bi-calendar-week-fill', menuOrder: 2,
            template: `<div id="student-calendar-component" class="h-100"></div>`,
            components: [
                {
                    name: 'student-calendar-main',
                    type: 'StudentCalendar',
                    container: 'student-calendar-component',
                    instanceId: 'studentCalendar'
                }
            ]
        },

        "student-coordinator": {
            route: '/student/coordinator',
            menuItem: true, menuTitle: 'My Coordinator', menuIcon: 'bi-person-workspace', menuOrder: 3,
            template: `<div id="student-coordinator-component" class="h-100"></div>`,
            components: [
                { name: 'student-coordinator-main', type: 'StudentCoordinatorCoPilot', container: 'student-coordinator-component', instanceId: 'studentCoordinator' }
            ]
        },
        "student-documentation": {
            route: '/student/notes',
            menuItem: true, menuTitle: 'My Notes', menuIcon: 'bi-journal-richtext', menuOrder: 4,
            template: `<div id="student-documentation-component" class="h-100"></div>`,
            components: [
                { name: 'student-docs-main', type: 'StudentDocumentationManager', container: 'student-documentation-component', instanceId: 'studentDocsManager' }
            ]
        },

        "student-schedule-list": {
            route: '/student/schedule',
            menuItem: true, menuTitle: 'My Classes', menuIcon: 'bi-card-list', menuOrder: 5,
            template: `<div id="student-schedule-list-component" class="h-100"></div>`,
            components: [
                { name: 'student-schedule-list-main', type: 'StudentClassScheduleView', container: 'student-schedule-list-component', instanceId: 'studentScheduleList' }
            ]
        },

        "student-courses": {
            route: '/student/courses',
            menuItem: true, menuTitle: 'My Courses', menuIcon: 'bi-journal-bookmark-fill', menuOrder: 6,
            template: `<div id="student-courses-component" class="h-100"></div>`,
            components: [{ name: 'student-course-list', type: 'StudentCourseListView', container: 'student-courses-component' }]
        },
        "student-profile": {
            route: '/student/profile', hideInMenu: true,
            template: `<div id="student-profile-view" class="h-100"></div>`,
            components: [
                { name: 'student-profile-main', type: 'UserProfile', container: 'student-profile-view' }
            ]
        },

        "student-certificates": {
            route: '/student/certificates',
            menuItem: true, menuTitle: 'My Certificates', menuIcon: 'bi-patch-check-fill', menuOrder: 7,
            template: `<div id="student-certificates-component" class="h-100"></div>`,
            components: [
                { name: 'student-certificates-main', type: 'StudentCertificatesView', container: 'student-certificates-component', instanceId: 'studentCertificates' }
            ]
        },

        "student-billing": {
            route: '/student/billing',
            menuItem: true, menuTitle: 'Billing', menuIcon: 'bi-credit-card-2-front-fill', menuOrder: 8,
            template: `<div id="student-billing-component-container" class="h-100"></div>`,
            components: [
                { name: 'student-billing-view', type: 'BillingView', container: 'student-billing-component-container' }
            ]
        },


        // --- PARENT, COURSE ADMIN, ADMIN LAYERS (Unchanged, but now part of 'app' layer) ---
        "parent": {
            route: '/parent',
            template: `
                <div class="d-flex h-100">
                    <nav id="parent-sidebar-menu" class="app-sidebar"></nav>
                    <div id="parent-content-area" class="flex-grow-1 p-1 overflow-auto"></div>
                </div>
            `,
            components: [
                { name: 'parent-menu', type: 'AppMenu', container: 'parent-sidebar-menu', props: { startingRoute: '/parent/', fullHeight: true } },
                { name: 'parent-content-layer', type: 'layer', layer: 'parent-content', container: 'parent-content-area', default: true },
                { name: 'parent-coordinator-layer', type: 'layer', layer: 'parent-coordinator', container: 'parent-feature-area' },
            ]
        },
        "parent-content": {
            template: `<div id="parent-feature-area" class="h-100"></div>`,
            components: [
                { name: 'parent-dashboard-layer', type: 'layer', layer: 'parent-dashboard', container: 'parent-feature-area', default: true },
                { name: 'parent-profile-layer', type: 'layer', layer: 'parent-profile', container: 'parent-feature-area' },
            ]
        },
        "parent-dashboard": {
            route: '/parent/dashboard',
            menuItem: true, menuTitle: "Child's Progress", menuIcon: 'bi-graph-up', menuOrder: 1,
            template: `<div id="parent-dashboard-component" class="h-100"></div>`,
            components: [
                { name: 'parent-dashboard-main', type: 'ParentDashboard', container: 'parent-dashboard-component', instanceId: 'parentDashboard' }
            ]
        },
        "parent-profile": {
            route: '/parent/profile', hideInMenu: true,
            template: `<div id="parent-profile-view" class="h-100"></div>`,
            components: [
                { name: 'parent-profile-main', type: 'UserProfile', container: 'parent-profile-view' }
            ]
        },

        "parent-coordinator": {
            route: '/parent/coordinator',
            menuItem: true, menuTitle: "Coordinator", menuIcon: 'bi-people', menuOrder: 2,
            template: `<div id="parent-coordinator-component" class="h-100"></div>`,
            components: [
                { name: 'parent-coordinator-main', type: 'ParentCoordinatorCoPilot', container: 'parent-coordinator-component', instanceId: 'parentCoordinator' }
            ]
        },


        "courseAdmin": {
            route: '/course-admin',
            template: `
                <div class="d-flex h-100">
                    <nav id="courseAdmin-sidebar-menu" class="app-sidebar"></nav>
                    <div id="courseAdmin-content-area" class="flex-grow-1 p-1 overflow-auto"></div>
                </div>
            `,
            components: [
                { name: 'courseAdmin-menu', type: 'AppMenu', container: 'courseAdmin-sidebar-menu', props: { startingRoute: '/course-admin/', fullHeight: true } },
                { name: 'courseAdmin-content-layer', type: 'layer', layer: 'courseAdmin-content', container: 'courseAdmin-content-area', default: true },
            ]
        },
        "courseAdmin-content": {
            template: `<div id="cadmin-feature-area" class="h-100"></div>`,
            components: [
                { name: 'courseAdmin-dashboard-layer', type: 'layer', layer: 'courseAdmin-dashboard', container: 'cadmin-feature-area', default: true },
                { name: 'courseAdmin-courses-layer', type: 'layer', layer: 'courseAdmin-courses', container: 'cadmin-feature-area' },
                { name: 'courseAdmin-profile-layer', type: 'layer', layer: 'courseAdmin-profile', container: 'cadmin-feature-area' },
                { name: 'cadmin-assistant-layer', type: 'layer', layer: 'cadmin-assistant', container: 'cadmin-feature-area' },
                { name: 'cadmin-course-documents-layer', type: 'layer', layer: 'cadmin-course-documents', container: 'cadmin-feature-area' },
            ]
        },
        "courseAdmin-dashboard": {
            route: '/course-admin/dashboard',
            menuItem: true, menuTitle: 'Overview', menuIcon: 'bi-speedometer2', menuOrder: 1,
            template: `<div id="courseAdmin-dashboard-component" class="h-100"></div>`,
            components: [
                { name: 'courseAdmin-dashboard-main', type: 'CAdminDashboard', container: 'courseAdmin-dashboard-component', instanceId: 'cAdminDashboard' }
            ]
        },
        "courseAdmin-courses": {
            route: '/course-admin/courses',
            menuItem: true, menuTitle: 'Manage Courses', menuIcon: 'bi-journals', menuOrder: 2,
            template: `<div id="courseAdmin-courses-component" class="h-100"></div>`,
            components: [
                { name: 'cadmin-course-crud', type: 'CAdminCourseCrud', container: 'courseAdmin-courses-component', instanceId: 'cAdminCourseCrud' }
            ]
        },
        "courseAdmin-profile": {
            route: '/course-admin/profile', hideInMenu: true,
            template: `<div id="courseAdmin-profile-view" class="h-100"></div>`,
            components: [
                { name: 'cadmin-profile-main', type: 'UserProfile', container: 'courseAdmin-profile-view' }
            ]
        },

        "cadmin-assistant": {
            route: '/course-admin/assistant',
            menuItem: true, menuTitle: 'Course Assistant', menuIcon: 'bi-robot', menuOrder: 3,
            template: `<div id="cadmin-assistant-component" class="h-100"></div>`,
            components: [
                { name: 'cadmin-assistant-main', type: 'CAdminCourseAssistantCoPilot', container: 'cadmin-assistant-component', instanceId: 'cadminAssistant' }
            ]
        },
        "cadmin-course-documents": {
            route: '/course-admin/course-documents', // Route matches navigation from CAdminCourseCrud
            menuItem: false, hideInMenu: true, menuTitle: 'Course Content Editor', menuIcon: 'bi-pencil-square', menuOrder: 5, // Example menu order
            template: `<div id="cadmin-documentation-component" class="h-100"></div>`,
            components: [
                { name: 'cadmin-docs-main', type: 'CAdminDocumentationManager', container: 'cadmin-documentation-component', instanceId: 'cadminDocsManager' }
            ]
        },


        "admin": {
            route: '/admin',
            template: `
                <div class="d-flex h-100">
                    <nav id="admin-sidebar-menu" class="app-sidebar"></nav>
                    <div id="admin-content-area" class="flex-grow-1 p-1 overflow-auto"></div>
                </div>
            `,
            components: [
                { name: 'admin-menu', type: 'AppMenu', container: 'admin-sidebar-menu', props: { startingRoute: '/admin/', fullHeight: true } },
                { name: 'admin-content-layer', type: 'layer', layer: 'admin-content', container: 'admin-content-area', default: true },
            ]
        },
        "admin-content": {
            template: `<div id="admin-feature-area" class="h-100"></div>`,
            components: [
                { name: 'admin-platform-dashboard-layer', type: 'layer', layer: 'admin-platform-dashboard', container: 'admin-feature-area', default: true },
                { name: 'admin-users-layer', type: 'layer', layer: 'admin-users', container: 'admin-feature-area' },
                { name: 'admin-user-config-layer', type: 'layer', layer: 'admin-user-config', container: 'admin-feature-area' },
                { name: 'admin-invite-codes-layer', type: 'layer', layer: 'admin-invite-codes', container: 'admin-feature-area' },
                { name: 'admin-profile-layer', type: 'layer', layer: 'admin-profile', container: 'admin-feature-area' },
                { name: 'admin-platform-assistant-layer', type: 'layer', layer: 'admin-platform-assistant', container: 'admin-feature-area' },


            ]
        },
        "admin-platform-dashboard": {
            route: '/admin/dashboard',
            menuItem: true, menuTitle: 'Platform Stats', menuIcon: 'bi-bar-chart-line-fill', menuOrder: 1,
            template: `<div id="admin-platform-dashboard-component" class="h-100"></div>`,
            components: [
                { name: 'admin-platform-dashboard-main', type: 'AdminPlatformDashboard', container: 'admin-platform-dashboard-component', instanceId: 'adminPlatformDashboard' }
            ]
        },
        "admin-users": {
            route: '/admin/users',
            menuItem: true, menuTitle: 'Manage Users', menuIcon: 'bi-people-fill', menuOrder: 2,
            template: `<div id="admin-users-component" class="h-100"></div>`,
            components: [
                { name: 'admin-user-manager', type: 'UserManager', container: 'admin-users-component', instanceId: 'adminUserManager' }
            ]
        },
        "admin-user-config": {
            route: '/admin/user-config', hideInMenu: true,
            template: `<div id="admin-user-config-view" class="h-100"></div>`,
            components: [
                { name: 'admin-user-config-main', type: 'UserConfigurationView', container: 'admin-user-config-view' }
            ]
        },
        "admin-invite-codes": { route: '/admin/invite-codes', menuOrder: 3, menuItem: true, menuTitle: 'Invite Codes', menuIcon: 'bi-key', template: `<div id="admin-invites-container" class="h-100"></div>`, components: [{ name: 'invite-code-manager', type: 'InviteCodeManager', container: 'admin-invites-container' }] },
        "admin-profile": {
            route: '/admin/profile', hideInMenu: true,
            template: `<div id="admin-profile-view" class="h-100"></div>`,
            components: [
                { name: 'admin-profile-main', type: 'UserProfile', container: 'admin-profile-view' }
            ]
        },

        "admin-platform-assistant": {
            route: '/admin/assistant',
            menuItem: true, menuTitle: 'Platform Assistant', menuIcon: 'bi-cpu-fill', menuOrder: 3,
            template: `<div id="admin-platform-assistant-component" class="h-100"></div>`,
            components: [
                { name: 'admin-assistant-main', type: 'AdminPlatformAssistantCoPilot', container: 'admin-platform-assistant-component', instanceId: 'adminPlatformAssistant' }
            ]
        },
    }
};
